import { map } from "rxjs/operators";
import { GET, POST } from "../../../module/services/fetch";
import { IDENTITY_SYSTEM } from "../../../module/constants";
export const fetchOfficeRequest = () =>
  GET("entitlement/ou").pipe(map((response: any) => response));

export const fetchOfficeEntitlementRequest = (id: string | number) =>
  GET(`entitlements?ou=${id}`).pipe(map((response: any) => response));

export const fetchEntitlementRequest = (obj: {}) =>
  POST("entitlements", obj).pipe(map((response: any) => response));

export const fetchCreateRequest = (abilitationObj: FormData) =>
  POST(
    "request/createRequests",
    abilitationObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const fetchChainEntitlementRequest = (ids: string[]) => {
  let queryParam: string = ids.join(",");

  /*
   * entitlements/entitlementsbyids?ids viene usata in altri contesti
   * per quanto riguarda la chain entitlements, è necessario che
   * identity_system_id sia "ITA" o "NOR" e non "1" o "2"
   * di seguito viene modificato il mapping
   */
  return GET(`entitlements/entitlementsbyids?ids=${queryParam}`).pipe(
    map((response: any[]) => {
      const mapped = response.map((entitlement) => ({
        ...entitlement,
        identity_system_id:
          IDENTITY_SYSTEM[
            entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
          ] || entitlement.identity_system_id,
      }));

      console.log("Mapped entitlements:", mapped);
      return mapped;
    })
  );
};

export const getPaginatedGlobalCatalogService = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `entitlements/findEntFromGlobal${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};
